import { css } from "@emotion/css";

import { Text, TextProps } from "./Text";

interface Props extends Omit<TextProps, "children"> {
  children?: string;
  highlight?: string;
}

export function HighlightText(props: Props) {
  const { children = "", highlight = "", ...textProps } = props;

  const parts = children.split(
    new RegExp(
      `(${highlight
        .replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&") //Escape regex special characters
        .split(" ")
        .join("|")})`,
      "gi"
    )
  );

  return (
    <Text {...textProps} className={css({ fontWeight: "400" })}>
      {parts.map((part, i) => (
        <span
          key={i}
          style={
            highlight.toLowerCase().split(" ").includes(part.toLowerCase())
              ? { fontWeight: "500" }
              : {}
          }
        >
          {part}
        </span>
      ))}
    </Text>
  );
}
